<template>
    <div class="devices-list__block" v-if="deviceData">
        <device-status :device="deviceData" :showLocation="showLocation" :edit="edit"/>
        <v-layout row class="devices-list__block__title" :class="{'device-btns-edit': edit}">
            <device-title :device="deviceData"></device-title>
            <div class="btn-group">
                <v-flex class="btn-block">
                    <device-switch-disabled :device-state="deviceData.state" :name="deviceData.uid"></device-switch-disabled>
                </v-flex>
            </div>
        </v-layout>
        <device-sensor-time v-if="deviceData.state" :time="deviceData.state.last_update"></device-sensor-time>
    </div>
</template>

<script>
export default {
    name: "OpeningSensorDevice",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        edit: {
            type: Boolean,
            default: false,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: {},
        };
    },
    created() {
        this.deviceData = this.device;
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
            }
        },
    },
}
</script>